/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FileManagementListFileForMemberRequest } from "../models/FileManagementListFileForMemberRequest";
import type { FileManagementListFileForMemberResponseApiRespoonse } from "../models/FileManagementListFileForMemberResponseApiRespoonse";
import type { MemberSearchListAlbumForMemberRequest } from "../models/MemberSearchListAlbumForMemberRequest";
import type { MemberSearchListAlbumForMemberResponseApiRespoonse } from "../models/MemberSearchListAlbumForMemberResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class AppGroupService {
  /**
   * Group files
   * @param requestBody
   * @returns FileManagementListFileForMemberResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static userGroupFiles(
    requestBody: FileManagementListFileForMemberRequest
  ): CancelablePromise<FileManagementListFileForMemberResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/group/files",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Group albums
   * @param requestBody
   * @returns MemberSearchListAlbumForMemberResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static userGroupAlbums(
    requestBody: MemberSearchListAlbumForMemberRequest
  ): CancelablePromise<MemberSearchListAlbumForMemberResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/group/albums",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
